/* tslint:disable */
/* eslint-disable */
/**
 * GLC.Portal.Api (local) Portal BFF
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 2.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * 
 * @export
 */
export const IAPPOLICYOWNERSHIP = {
    MemberOwned: '1',
    FundOwned: '2'
} as const;
export type IAPPOLICYOWNERSHIP = typeof IAPPOLICYOWNERSHIP[keyof typeof IAPPOLICYOWNERSHIP];


export function IAPPOLICYOWNERSHIPFromJSON(json: any): IAPPOLICYOWNERSHIP {
    return IAPPOLICYOWNERSHIPFromJSONTyped(json, false);
}

export function IAPPOLICYOWNERSHIPFromJSONTyped(json: any, ignoreDiscriminator: boolean): IAPPOLICYOWNERSHIP {
    return json as IAPPOLICYOWNERSHIP;
}

export function IAPPOLICYOWNERSHIPToJSON(value?: IAPPOLICYOWNERSHIP | null): any {
    return value as any;
}

